<div>
  <h2 mat-dialog-title>Vælg butikker</h2>
  <mat-dialog-content>
    <section *ngIf="retainedUnavailableStores.length">
      <h3>Inaktive butikker i denne udsendelse</h3>
      <p>De eksisterende valg kan beholdes eller fjernes. Inaktive butikker kan ikke vælges til nye udsendelser.</p>
      <div *ngFor="let store of retainedUnavailableStores; trackBy: trackStore">
        <mat-checkbox [checked]="isSelected(store)" (change)="onStoreToggled(store)">{{store.id}} · {{store.place}}</mat-checkbox>
      </div>
    </section>
    <div *ngFor="let district of storeDistricts$ | async; trackBy: trackDistrict">
      <div class="group-header">
        <mat-checkbox [checked]="isDistrictSelected(district)" [indeterminate]="isDistrictIndeterminate(district)" (change)="toggleDistrict(district, $event.checked)">
          {{ district.name }}
        </mat-checkbox>
      </div>

      <mat-selection-list>
        <div class="multi-column">
          <mat-list-option *ngFor="let store of district.stores; trackBy: trackStore" [value]="store" [selected]="isSelected(store)" (click)="onStoreToggled(store)">
            <h5 matListItemTitle>{{ store.id }}</h5>
            <div matListItemLine>{{ store.place }}</div>
          </mat-list-option>
        </div>
      </mat-selection-list>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <!-- <button mat-button mat-dialog-close>Cancel</button> -->
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-button [mat-dialog-close]="{ selectedStores: this.selectedStores}">OK</button>
  </mat-dialog-actions>
</div>
